const prefix = 'user-table';

export const userTableI18n = {
    uuid: {
        id: `${prefix}.uuid`,
        defaultMessage: 'UUID',
    },
    seequentId: {
        id: `${prefix}.seequentId`,
        defaultMessage: 'Seequent ID',
    },
    login: {
        id: `${prefix}.login`,
        defaultMessage: 'Login',
    },
    email: {
        id: `${prefix}.email`,
        defaultMessage: 'Email',
    },
    type: {
        id: `${prefix}.type`,
        defaultMessage: 'Type',
    },
    owner: {
        id: `${prefix}.owner`,
        defaultMessage: 'Owner',
    },
    nonOwner: {
        id: `${prefix}.nonOwner`,
        defaultMessage: 'Non-Owner',
    },
    status: {
        id: `${prefix}.status`,
        defaultMessage: 'Status',
    },
    typeImago: {
        id: `${prefix}.typeImago`,
        defaultMessage: 'Imago',
    },
    typeSso: {
        id: `${prefix}.typeSso`,
        defaultMessage: 'SSO',
    },
    typeSqid: {
        id: `${prefix}.typeSqid`,
        defaultMessage: 'SQID',
    },
    typeInvited: {
        id: `${prefix}.typeInvited`,
        defaultMessage: 'Invited',
    },
    noUsersTitle: {
        id: `${prefix}.noUsersTitle`,
        defaultMessage: 'No users',
    },
    loadErrorTitle: {
        id: `${prefix}.loadErrorTitle`,
        defaultMessage: 'Could not load users',
    },
    loadErrorMessage: {
        id: `${prefix}.loadErrorMessage`,
        defaultMessage: 'Refresh the page to try again.',
    },
} as const;
